export const ShippingZonesTableColumns = [
    {
        id: "name",
        labelEn: "Name",
        labelAr: "الاسم",
        align: "left",
        sortable: true,
    },
    {
        id: "locations_count",
        labelEn: "Locations",
        labelAr: "المواقع",
        align: "center",
        sortable: false,
    },
    {
        id: "methods_count",
        labelEn: "Methods",
        labelAr: "الطرق",
        align: "center",
        sortable: false,
    },
    {
        id: "is_active",
        labelEn: "Active",
        labelAr: "نشط",
        align: "center",
        sortable: false,
    },
];
